import { Grid } from '@ltvco/refresh-lib/theme';
import { type ReactNode } from 'react';

import { PromoCtaButton, PromoFeatureCard } from './PromoFeatureCard';

export type BulkImportPromoCardProps = {
  isCompactLayout: boolean;
  mdColumns: number;
  illustration: ReactNode;
  onBulkUpload: () => void;
};

export function BulkImportPromoCard({
  isCompactLayout,
  mdColumns,
  illustration,
  onBulkUpload,
}: BulkImportPromoCardProps) {
  const ctaSxCompact = isCompactLayout ? { flexShrink: 0 as const } : undefined;

  return (
    <Grid
      size={{ xs: 12, md: mdColumns }}
      sx={{ display: 'flex', alignItems: 'stretch' }}
    >
      <PromoFeatureCard
        isCompactLayout={isCompactLayout}
        illustration={illustration}
        title="Bulk Import Addresses"
        body="Upload multiple addresses at once and build lists quickly to find owner and property details."
        cta={
          <PromoCtaButton
            variant="contained"
            color="primary"
            onClick={onBulkUpload}
            sx={ctaSxCompact}
          >
            Start Bulk Import
          </PromoCtaButton>
        }
      />
    </Grid>
  );
}
